export const SkipStepExperimentEnum = Object.freeze({
  'skip': 'skip',
  'dontSkip': 'dontSkip',
})
